.root {
  line-height: var(--font-line-height);
  color: inherit;
}

.wordBreak {
  overflow-wrap: break-word;
}

.block {
  display: block;
}

.marginsNone {
  margin-top: 0;
  margin-bottom: 0;
}

.align-inherit {
  text-align: inherit;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.align-center {
  text-align: center;
}

.upperCase {
  text-transform: uppercase;
}

.h1 {
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-regular);

  @media (--md-down) {
    font-size: var(--font-size-h1-phone);
  }
}

.h2 {
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-regular);

  @media (--md-down) {
    font-size: var(--font-size-h2-phone);
  }
}

.h3 {
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-regular);

  @media (--md-down) {
    font-size: var(--font-size-h3-phone);
  }
}

.h4 {
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--font-small-letter-spacing);
}

.h5 {
  font-size: var(--font-size-h5);
  font-weight: var(--font-weight-light);
  letter-spacing: var(--font-small-letter-spacing);
}

.h6 {
  font-size: var(--font-size-h6);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--font-small-letter-spacing);
}

.subtitle-1 {
  font-size: var(--font-size-subtitle-1);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--font-small-letter-spacing);
}

.subtitle-2 {
  font-size: var(--font-size-subtitle-2);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--font-small-letter-spacing);
}

.body-1 {
  font-size: var(--font-size-body-1);
  font-weight: var(--font-weight-light);
  line-height: 140%;
  letter-spacing: var(--font-small-letter-spacing);
}

.body-2 {
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-light);
  line-height: 140%;
  letter-spacing: var(--font-small-letter-spacing);
}

.caption {
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--font-small-letter-spacing);
}

.small {
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--font-small-letter-spacing);
}

.monospace {
  font-family: var(--font-mono);
  font-size: var(--font-size-monospace);
  line-height: 1.5em;
  letter-spacing: unset;

  @media (--md-down) {
    font-size: 13px;
  }
}

.error {
  font-size: var(--font-size-body-1);
  color: var(--sentiment-negative);
}
